import { motion } from "framer-motion";

interface QuestionSatisfactionProps {
  onNext: () => void;
  onBack: () => void;
  value: number;
  onChange: (value: number) => void;
}

const labels: Record<number, string> = {
  1: "Heel ontevreden",
  2: "Ontevreden",
  3: "Matig",
  4: "Niet geweldig",
  5: "Gemiddeld",
  6: "Redelijk",
  7: "Best goed",
  8: "Tevreden",
  9: "Heel tevreden",
  10: "Helemaal tevreden",
};

const QuestionSatisfaction = ({ onNext, onBack, value, onChange }: QuestionSatisfactionProps) => {

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
      >
        <span className="text-xl">←</span> Terug
      </button>

      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-2 leading-tight">
          Hoe tevreden ben je met je huid op dit moment?
        </h2>
        <p className="text-foreground/80 font-sans text-lg mb-6 md:mb-10">
          Tik op het cijfer dat het beste bij je past
        </p>

        <div className="grid grid-cols-5 gap-2 md:gap-3 mb-4">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
            <motion.button
              key={num}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.03 * num }}
              onClick={() => onChange(num)}
              className={`aspect-square rounded-xl border-2 flex items-center justify-center text-xl md:text-2xl font-serif font-bold transition-all duration-200 ${
                value === num
                  ? "border-primary bg-primary/10 text-primary scale-110 shadow-md"
                  : "border-border bg-white text-foreground/70 hover:border-primary/40 hover:bg-primary/5"
              }`}
            >
              {num}
            </motion.button>
          ))}
        </div>

        {value && (
          <motion.p
            key={value}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-foreground font-sans text-lg font-medium mb-2"
          >
            {labels[value]}
          </motion.p>
        )}

        <div className="flex justify-between text-[15px] text-foreground/60 font-sans mt-1 px-1">
          <span>Heel ontevreden</span>
          <span>Helemaal tevreden</span>
        </div>

        {/* Seeding: if score is low, reinforce it's not their fault */}
        {value <= 5 && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-foreground/75 font-sans text-lg mt-8 italic"
          >
            De meeste vrouwen geven een {value} of lager. Dat verandert wanneer je de juiste aanpak vindt.
          </motion.p>
        )}

        <div className="mt-6 md:mt-10">
          <button onClick={onNext} className="btn-cta">
            Volgende
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionSatisfaction;
